import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { isValidEmail, sendPublicEmail } from "../Services/publicEmailService";

export default function Newsletter() {
  const { t, i18n } = useTranslation();
  const [pending, setPending] = useState(false);
  const sending = useRef(false);
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [invalid, setInvalid] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (sending.current) return;
    const input = event.currentTarget.elements.email;
    const valid = input.validity.valid && isValidEmail(email.trim());
    setInvalid(!valid);
    setStatus("");
    if (!valid) { setStatus("invalidEmail"); input.focus(); return; }
    sending.current = true;
    setPending(true);
    try {
      await sendPublicEmail("newsletter", { email: email.trim() });
      setEmail("");
      setStatus("newsletterSuccess");
    } catch (error) {
      setStatus("sendError");
    } finally {
      sending.current = false;
      setPending(false);
    }
  };

  return (
    <section lang={i18n.resolvedLanguage} aria-labelledby="newsletter-title" className="mb-12 rounded-3xl border border-white/10 bg-white/5 p-6 sm:p-8">
      <div className="grid items-center gap-6 lg:grid-cols-2">
        <div>
          <h2 id="newsletter-title" className="text-2xl font-bold text-white">{t("publicEmail.newsletterTitle")}</h2>
          <p className="mt-3 text-sm leading-6 text-slate-300">{t("publicEmail.newsletterText")}</p>
        </div>
        <form onSubmit={submit} noValidate aria-busy={pending}>
          <label htmlFor="newsletter-email" className="mb-2 block text-sm text-white">{t("publicEmail.emailPlaceholder")}</label>
          <div className="flex flex-col gap-3 sm:flex-row">
            <input id="newsletter-email" name="email" type="email" dir="ltr" disabled={pending} required autoComplete="email" maxLength={254}
              value={email} onChange={(event) => { setEmail(event.target.value); setStatus(""); setInvalid(false); }}
              aria-invalid={invalid} aria-describedby="newsletter-status" placeholder={t("publicEmail.emailPlaceholder")}
              className="min-w-0 flex-1 rounded-xl border border-slate-600 bg-slate-900 px-4 py-3 text-white outline-none focus:border-green-400 focus:ring-2 focus:ring-green-400" />
            <button type="submit" disabled={pending} className="rounded-xl bg-green-600 px-6 py-3 font-bold text-white hover:bg-green-700 disabled:opacity-60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-400">{t(`publicEmail.${pending ? "sending" : "subscribe"}`)}</button>
          </div>
          <p id="newsletter-status" role="status" aria-live="polite" className={`mt-3 text-sm ${status && status !== "newsletterSuccess" ? "text-amber-300" : "text-slate-300"}`}>{status && t(`publicEmail.${status}`)}</p>
        </form>
      </div>
    </section>
  );
}
